
export class Collection {
  id: string = '';
  title: string = '';
  description: string = '';
  rootUrl: string = '';
  collectionUrl: string = '';
  queryablesUrl: string = '';
  uiSearchFields: any = undefined;
  sortSupported = true;

  constructor(id:string, title:string, description:string, rootUrl:string, collectionUrl:string, queryablesUrl:string) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.rootUrl = rootUrl;
    this.collectionUrl = collectionUrl;
    this.queryablesUrl = queryablesUrl;
  }
}
